import { connect } from 'react-redux';
import * as PaymentAction from './PaymentAction';

const ExperienceInjector =
    (stateToProps = null, dispatchToProps = null) =>
    (WrapperComponent) => {
        const mapDispatchToProps = (dispatch, ownProps) => {
            let props = {};
            if (dispatchToProps !== null) {
                props = dispatchToProps(dispatch, ownProps);
            }
            return {
                completedAction: () => {
                    dispatch(PaymentAction.completedAction());
                },
                //부모 정보
                setUserInfo: (userInfo) => {
                    dispatch(PaymentAction.setUserInfo(userInfo));
                },
                // 선택된 아이 리스트 설정
                setSelectedStudentInfoList: (studentInfoList) => {
                    dispatch(PaymentAction.setSelectedStudentInfoList(studentInfoList));
                },
                //아이선택
                getSelectedStudentInfo: (studentInfo) => {
                    dispatch(PaymentAction.getSelectedStudentInfo(studentInfo));
                },
                // 선택된 아이 리스트 설정
                setStudentInfoList: (studentInfoList) => {
                    dispatch(PaymentAction.setStudentInfoList(studentInfoList));
                },
                //체크리스트
                setCheckList: (checkList) => {
                    dispatch(PaymentAction.setCheckList(checkList));
                },
                //체크 초기화
                initCheckList: () => {
                    dispatch(PaymentAction.initCheckList());
                },
                //체험 카운트
                getExperienceCount: (studentList) => {
                    dispatch(PaymentAction.getExperienceCount(studentList));
                },
                //배송메세지
                modifyDeliveryMessage: (issueId, message) => {
                    dispatch(PaymentAction.modifyDeliveryMessage(issueId, message));
                },
                applyStudy: (studentId, levels, channel, deliveryMessage, experienceFlag, register_code) => {
                    dispatch(
                        PaymentAction.applyStudy(
                            studentId,
                            levels,
                            channel,
                            deliveryMessage,
                            experienceFlag,
                            register_code
                        )
                    );
                },
                initDataForNotLogin: () => {
                    dispatch(PaymentAction.initDataForNotLogin());
                },
                applySimple: () => {
                    dispatch(PaymentAction.applySimple());
                },
                ...props,
            };
        };
        const mapStateToProps = (state, ownProps) => {
            let props = {};
            if (stateToProps !== null) {
                props = stateToProps(state, ownProps);
            }
            return {
                //TODO refactor
                // 학생 & 부모 정보
                user_info: state.PaymentReducer.user_info,
                userInfo: state.PaymentReducer.user_info,
                //학습신청 상태
                applyType: state.PaymentReducer.applyType,
                experienceCount: state.PaymentReducer.experienceCount,
                isApply: state.PaymentReducer.action === 'successapply',
                isModifyMessage: state.PaymentReducer.action === 'modifymassage',

                //아이선택
                selectedStudentInfoList: state.PaymentReducer.selectedStudentInfoList,
                selectedStudentInfo: state.PaymentReducer.selectedStudentInfo,
                studentInfoList: state.PaymentReducer.studentInfoList,
                checkList: state.PaymentReducer.checkList,
                studentPaymentContractListInfo: state.PaymentReducer.studentPaymentContractListInfo,
                ...props,
            };
        };

        return connect(mapStateToProps, mapDispatchToProps)(WrapperComponent);
    };

export default ExperienceInjector;
